// extracted by mini-css-extract-plugin
export default {"container":"Widgets_container__nyded"};